import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../../popover';
import Paragraph from '../../paragraph';

const ValuePopover = ({ mode, value, title = '', imgSrc = '', content = '', isOpen }) => (
  <div className="ws-ui-slider-pattern__value-popover">
    <Popover
      mode={mode}
      placement="top-right"
      title={title}
      description={content}
      appearance="dark"
      imgSrc={imgSrc}
      isOpen={isOpen}
    >
      <PopoverTrigger>
        <Paragraph>{value}</Paragraph>
      </PopoverTrigger>

      <PopoverContent />
    </Popover>
  </div>
);

export default ValuePopover;
